import Image from 'next/image';

export default function LoginIllustration() {
  return (
    <div className="relative w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-blue-700 via-blue-600 to-blue-800 overflow-hidden">
      {/* Background decorative circles */}
      <div className="absolute top-[-80px] right-[-80px] w-[300px] h-[300px] rounded-full bg-white/5" />
      <div className="absolute bottom-[-120px] left-[-60px] w-[400px] h-[400px] rounded-full bg-white/5" />
      <div className="absolute top-1/2 left-1/4 w-[200px] h-[200px] rounded-full bg-white/[0.03]" />

      <div className="relative z-10 flex flex-col items-center gap-8">
        <div className="bg-white rounded-3xl p-10 shadow-2xl shadow-black/20">
          <Image
            src="/logo_aplaco.png"
            alt="Aplaco Logo"
            width={220}
            height={220}
            className="object-contain"
            priority
          />
        </div>
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white tracking-wide mb-2">Aplaco ERP</h1>
          <p className="text-blue-200 text-base">Hệ thống quản lý sản xuất</p>
        </div>
      </div>
    </div>
  );
}

